
import { orderItemsSelector } from '@redux/slices/order';
import { Col, Row } from 'antd';
import React, { memo } from 'react';
import { CustomerCollapse } from './customer-collapse';
import { SelectItemsFilters } from './select-items-filters';
import { useQuery as useQueryHooks } from '@hooks/use-query';
import { SolidBackground } from '@styles/components/wrapper';
import { useSelector } from 'react-redux';
import { UserInfoCollapse } from './user-info-collapse';
import '@extensions/number';
import { SelectItemsHeaderFooter } from './select-items-header-footer';
import { balanceSelector } from '@redux/slices/balance';
import { Balance } from './balance';

interface SelectItemsHeaderProps {
    readOnly?: boolean;
    marketing?: boolean;
    bonification?: boolean;
}

export const SelectItemsHeaderMarketingBonification: React.FC<SelectItemsHeaderProps> = memo(
    () => {
        const selectItemsState = useSelector(orderItemsSelector);
        const balanceState = useSelector(balanceSelector)
        const query = useQueryHooks();

        const showUserInfo = selectItemsState.order?.userBonification &&
            selectItemsState.order?.userBonification.name

        const showSchedule = !!query.get('scheduled')

        return (
            <Col>
                <SolidBackground isWhite>
                    <Row style={{ padding: 30 }}>
                        <Col span={24}>
                            <Row justify="space-between" align="top">
                                <Col xs={24} md={showSchedule ? 18 : 21}>
                                    <Row gutter={24}>
                                        <Col xs={24} md={10}>
                                            <CustomerCollapse
                                                customer={selectItemsState.order.customer}
                                            />
                                        </Col>
                                        {showUserInfo && (
                                            <Col xs={24} md={6}>
                                                <UserInfoCollapse
                                                    user={selectItemsState.order?.userBonification || {}}
                                                />
                                            </Col>
                                        )}
                                        {!!balanceState.useBalance && (
                                            <Col xs={24} md={showUserInfo ? 6 : 12}>
                                                <Balance />
                                            </Col>
                                        )}
                                    </Row>
                                </Col>
                                <Col xs={24} md={showSchedule ? 6 : 3}>
                                    <SelectItemsFilters bonification marketing />
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </SolidBackground>
                <SelectItemsHeaderFooter bonification />
            </Col>
        );
    },
);
